export default __webpack_public_path__ + "static/media/guitar_inactive.59adde41.svg";